// Texty košíku a pokladny (checkoutPage.js). Čísla a data (práh, kg, kontakt)
// dodává modul, texty je jen skládají.
import { NBSP } from '../../modules/money.js';
import { plural } from '../plural.js';

export default {
  continueShopping: 'Pokračovat v nákupu',
  relatedMore: 'Související produkty',
  /** hlavička karty doplňkových služeb fvStudio */
  servicesTitle: 'Volitelné doplňkové služby',
  servicesNote: 'není nutné k dokončení objednávky',
  giftLabel: 'Dárek',
  sumTitle: 'Rekapitulace objednávky',
  hintNext: 'Doprava a platba v dalším kroku',
  goodsLabel: 'Zboží celkem',
  /** žlutý pásek pod „Cena bez DPH" (za ním částka) */
  savedLabel: 'Ušetřili jste ',
  totalLabel: 'Celkem k úhradě',
  notePlaceholder: 'Vaše poznámka…',
  pickNote: 'Bez zvoleného výdejního místa nelze pokračovat.',
  couponApply: 'Použít',
  couponPlaceholder: 'Slevový kupón',
  ctaCart: 'Pokračovat k dopravě',
  ctaShipping: 'Pokračovat k údajům',
  backShipping: 'Zpět do košíku',
  backInfo: 'Zpět k dopravě',
  paySecure: 'Zabezpečené a šifrované',
  shipTitle: 'Způsob dopravy',
  payTitle: 'Způsob platby',
  contactTitle: 'Kontaktní údaje',
  cartPickupLead: 'Vyzvednutí možné od:',
  /** trust pás pokladny */
  trustSecureTitle: 'Bezpečná platba',
  trustSecureText: 'SSL certifikát a 3D Secure',
  trustFreeShipTitle: 'Doprava zdarma',
  trustReturnTitle: '14 dní na vrácení',
  trustReturnText: 'Bez udání důvodu',
  trustHelpTitle: 'Poradíme s výběrem',
  trustShopTitle: 'Ověřený obchod',
  /** procento z řádku Heureky v manifestu (reviews.platforms, nativní metrika Heureky) */
  trustShopText: (pct) => 'Na Heurece nás doporučuje ' + pct + '\u00A0% zákazníků',
  /** náhradní dlaždice shopu bez hodnoticí platformy (cena z ceníku dopravy) */
  trustShipFromTitle: 'Doprava po celé ČR',
  trustShipFromText: (from) => 'od ' + from,
  /** dlaždice dopravy zdarma: „Na výdejní místo nad 2 000 Kč do 10 kg" */
  freeShipping: (from, kg) => 'Na výdejní místo nad ' + from + ' do ' + kg + NBSP + 'kg',
  footTerms: 'Obchodní podmínky',
  footShipping: 'Doprava a platba',
  footPrivacy: 'Ochrana osobních údajů',
  footContact: 'Kontakty',
  emptyTitle: 'Váš košík je prázdný',
  emptyText: 'Vyberte si z více než 5 000 kusů nářadí, zahradní techniky a vybavení do dílny.',
  emptyCta: 'Zpět do obchodu',
  /** „1 položka / 2 položky / 5 položek" */
  items: (n) => n + ' ' + plural(n, ['položka', 'položky', 'položek']),
  helpCall: (phone) => 'Zavolat ' + phone,
  helpMail: (email) => 'Napsat ' + email,
  helpHours: (hours) => hours + ', poradíme',
  /** bar výhod v košíku */
  msHeadBoth: 'Máte dárek i dopravu zdarma',
  msHeadGift: 'Máte dárek zdarma',
  msHeadShip: 'Máte dopravu zdarma',
  msHeadNone: 'Vaše výhody k objednávce',
  msSubShip: (left) => 'Ještě ' + left + ' do dopravy zdarma',
  msSubGift: (left) => 'Ještě ' + left + ' do dárku',
  msSubGoods: (goods) => 'Hodnota zboží ' + goods,
  msLabelGift: 'Dárek zdarma',
  msLabelShip: 'Doprava zdarma',
  msShipKg: (kg) => ' · do ' + kg + NBSP + 'kg',
  msBarLabel: 'Postup k výhodám objednávky',
  cartTitle: 'Nákupní košík',
  removeItem: 'Odstranit z košíku',
  free: 'Zdarma',
  priceFrom: (price) => 'od ' + price,
  /** termín kroku 2: „dnes 21.8." / „v sobotu 22.8." (index = getDay()) */
  etaToday: (dm) => 'dnes ' + dm,
  etaDays: ['v neděli', 'v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu'],
  /** serverová hláška Shoptetu „Odběrné místo … nebylo vybráno" (čte se) */
  pickupMissingRe: /nebylo vybr/i,
  donePayLabel: 'Údaje k platbě',
  ctaFallback: 'Pokračovat',
  /** štítek v názvu metody za akční cenu dopravy (#322): „Akce do 25. 10." */
  promoTag: (until) => 'Akce do ' + until,
  /** řádek akce v baru výhod košíku: „Akce: PPL na výdejní místo do 10 kg za 19 Kč, platí do 25. 10." */
  promoLine: (carrier, price, maxKg, until) =>
    'Akce: ' + carrier + ' na výdejní místo do ' + maxKg + NBSP + 'kg za ' + price + ', platí do ' + until.replace(/\.$/, '') + '.',
};
